import * as GatewayLogging from '@interopio/gateway/logging/core';

export import Logger = GatewayLogging.Logger;

export default function getLogger(name: string): Logger {
    return GatewayLogging.getLogger(`gateway.server.${name}`);
}

// This function is used to ensure that RegExp objects are displayed correctly when logging.
export function regexAwareReplacer<T>(_key: string, value: T): string | T {
    return value instanceof RegExp ? value.toString() : value;
}
